package fyi.moko.hotpl.domain.usecase

import fyi.moko.hotpl.data.backup.LocalBackupManager
import fyi.moko.hotpl.data.backup.PreparedHotplBackup
import fyi.moko.hotpl.domain.service.AuthService

class RestoreBackupUseCase(
    private val backupManager: LocalBackupManager,
) {
    suspend operator fun invoke(prepared: PreparedHotplBackup) {
        backupManager.restore(prepared)
    }
}